<template>
  <section class="results">
    <div class="filters mb-4">
      <filters v-if="!isShowingAnnexes" @change="reloadResources" @filters="handleFilterChange"/>
      <filters-anexo
        v-if="isShowingAnnexes"
        @change="reloadResources"
        @filtersAnnexes="handleFilterChangeAnnexes"
      />
    </div>
    <div class="data" v-if="resources.length">
      <div
        class="title d-flex justify-content-between align-items-center mb-4 mt-4"
        v-if="!isLoading"
      >
        <h3>{{resultsTitle}}</h3>
        <span class="float-right">{{ counter }}</span>
      </div>
      <div class="path">{{ breadcrumbs }}</div>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="learning" scope="col">Aprendizaje esperado</th>
              <th class="competition" scope="col">Competencia a favorecer</th>
              <th class="what_to_find" scope="col">¿Qué encontrarás?</th>
              <th class="resource" scope="col">Recurso</th>
              <th class="type" scope="col">Tipo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in resources" :key="item.id">
              <td class="learning">{{item.expected_learning}}</td>
              <td class="competition">{{item.competition}}</td>
              <td class="what_to_find">{{item.what_to_find}}</td>
              <td class="resource">
                <a :href="item.resource" target="_blank">Ir a recurso</a>
              </td>
              <td class="type">{{item.cat}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="empty" v-if="!resources.length && !isLoading">
      <h4>No se encontraron resultados.</h4>
    </div>
    <paginate
      class="mt-5"
      v-if="totalPages > 1"
      v-model="page"
      v-show="!isLoading"
      :page-count="totalPages"
      :prev-text="'Anterior'"
      :next-text="'Siguiente'"
      :container-class="'pagination d-flex justify-content-center'"
      :page-link-class="'page-link'"
      :page-class="'page-item'"
      :prev-link-class="'page-link'"
      :prev-class="'page-item'"
      :next-link-class="'page-link'"
      :next-class="'page-item'"
      :clickHandler="handlePaginationClick"
    ></paginate>
  </section>
</template>

<script>
import axios from 'axios';
import Filters from './Filters.vue';
import FiltersAnexo from './FiltersAnexo.vue';

export default {
  components: {
    Filters,
    FiltersAnexo,
  },
  data() {
    return {
      siteUrl: window.ui_school_data.site_url,
      apiPath: 'wp-json/resources/v1',
      resources: [],
      isLoading: true,
      page: 1,
      totalPages: 0,
      totalResources: 0,
      maxPages: 0,
      resourcesPerPage: 0,
      filters: null,
      isShowingAnnexes: false,
    };
  },
  computed: {
    resultsTitle() {
      return this.isShowingAnnexes
        ? `${this.totalResources} Recursos`
        : `${this.totalResources} Recursos escolares`;
    },
    breadcrumbs() {
      return '';
    },
    counter() {
      const initial =        this.page * this.resourcesPerPage + 1 - this.resourcesPerPage;
      let final = this.page * this.resourcesPerPage;
      final = final > this.totalResources ? this.totalResources : final;
      return `${initial} - ${final} de ${this.totalResources}`;
    },
  },
  mounted() {
    this.getResources();
  },
  methods: {
    getResources() {
      this.resources = [];
      this.totalPages = 0;
      this.totalResources = 0;
      this.maxPages = 0;
      this.isLoading = true;
      const apiUrl = `${this.siteUrl}/${this.apiPath}/resources`;
      axios
        .post(apiUrl, {
          page: this.page,
          ...this.filters,
        })
        .then((response) => {
          if (response.status === 200) {
            this.resources = response.data.resources;
            this.page = response.data.page;
            this.totalPages = response.data.max_num_pages;
            this.totalResources = response.data.total;
            this.maxPages = response.data.max;
            this.resourcesPerPage = response.data.posts_per_page;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log('error :', error);
          this.isLoading = false;
        });
    },
    reloadResources(filters) {
      this.filters = filters;
      this.getResources();
    },
    handlePaginationClick(pageNum) {
      this.page = pageNum;
      this.getResources();
    },
    handleFilterChange(filters) {
      this.isShowingAnnexes = true;
      this.reloadResources(filters);
    },
    handleFilterChangeAnnexes(filters) {
      this.isShowingAnnexes = false;
      this.reloadResources(filters);
    },
  },
};
</script>

<style scoped lang="scss">
.results {
  thead {
    background: #eafaf6;
    .learning {
      width: 20%;
    }
    .competition {
      width: 26%;
    }
    .what_to_find {
      width: 26%;
    }
    .resource {
      width: 12%;
      text-align: center !important;
    }
    .type {
      width: 12%;
      text-align: center !important;
    }
  }
  tbody {
    .resource {
      text-align: center !important;
      text-decoration: underline;
    }
    .type {
      text-align: center !important;
      font-weight: bold;
    }
  }

  .col,
  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col-auto,
  .col-lg,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-auto,
  .col-md,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-auto,
  .col-sm,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-auto,
  .col-xl,
  .col-xl-1,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl-auto {
    position: relative !important;
    width: 100% !important;
    min-height: 1px !important;
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
}
</style>
